import { useEffect, useState } from "react";

import { CSK_DEV_LAN_ORIGIN } from "src/utils/dev-lan-url";

interface DevLanOriginResponse {
  origin: string;
}

/**
 * Resolves the LAN origin for dev device QR / copy-link.
 * Auto-detects via /api/dev-lan-origin on each load; env override is fallback only.
 */
export function useCskDevLanOrigin(): {
  lanOrigin: string | null;
  loading: boolean;
} {
  const [lanOrigin, setLanOrigin] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const resolve = async () => {
      try {
        const response = await fetch("/api/dev-lan-origin");
        if (!response.ok) {
          throw new Error(`dev-lan-origin ${response.status}`);
        }
        const data = (await response.json()) as DevLanOriginResponse;
        if (!cancelled) {
          setLanOrigin(data.origin);
        }
      } catch {
        if (!cancelled) {
          setLanOrigin(CSK_DEV_LAN_ORIGIN || null);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    void resolve();

    return () => {
      cancelled = true;
    };
  }, []);

  return { lanOrigin, loading };
}
